import { useUrlQueryUid2Field } from "components/form";
import DefaultCrudForm from "components/form/DefaultCrudForm";
import { fetchArray } from "entity";
import { useSearchParams, useNavigate } from "react-router-dom";
import Rodada from "entity/Rodada";
import React, { useCallback, useEffect, useState } from "react";
import InscricaoEntity from "entity/Inscricao";
import { formatHorarioString } from "util/string";
import PainelDeReunioes from "entity/Rodada/components/PainelControle/PainelDeReunioes";
import _ from "lodash";
import useNotification from "notification";
import TabContainer from "components/tabs/TabContainer";
import TabPanel from "components/tabs/TabPanel";
import MatchsIncricao from "./MatchsIncricao";
import { generateUid } from "util/object";
import { Button, CircularProgress, Typography } from "@mui/material";
import { KeyboardReturn } from "@mui/icons-material";

import Reuniao from "entity/Reuniao";

function NovoAssistenteAgendamentoInt(props) {
    useUrlQueryUid2Field("rodada", "rodada", Rodada, props.form);

    const { rodada } = props.values;
    const [inscricoes, setInscricoes] = useState();
    const [mesasReunioes, setMesasReunioes] = useState();
    const [reunioesDeletar, setReunioesDeletar] = useState();
    const [reunioes, setReunioes] = useState();
    const [reunioesSalvas, setReunioesSalvas] = useState();
    const [isSaving, setIsSaving] = useState();
    const [matchs, setMatchs] = useState({});
    const [tab, setTab] = useState(0);
    const [searchParams] = useSearchParams();
    const searchRodada = searchParams.get("rodada");
    const navigate = useNavigate();
    const { showError, showSuccess } = useNotification();

    const loadInscricao = useCallback(async () => {
        if (rodada) {
            const horariosPossiveis = rodada ? rodada.possiveisReunioes : [];
            let newReunioes = [];
            const criaPreReuniao = (horario, mesa) => {
                return {
                    uid: generateUid(),
                    horario,
                    horariotxt: formatHorarioString(horario.horario),
                    mesa: mesa,
                    rodada: rodada,
                    isNew: true,
                    status: "ATIVO",
                };
            };
            if (!mesasReunioes) {
                let novasMesas = rodada.mesas || [];

                let novasMesasr = novasMesas.map((mesa) => {
                    newReunioes = newReunioes.concat(
                        horariosPossiveis.map((h, index) => {
                            return criaPreReuniao(h, mesa);
                        })
                    );

                    return { ...mesa };
                });
                setMesasReunioes(novasMesasr);
                setReunioes(newReunioes);
                mesclaReunioes(newReunioes, reunioesSalvas);
            }

            if (rodada && !inscricoes) {
                let resultInscricoes = await fetchArray(
                    InscricaoEntity.collection
                        .where("rodada.uid", "==", rodada.uid)
                        .where("status", "==", "INSCRITO")
                        .get()
                );

                // resultInscricoes.sort((a, b) => a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1)
                resultInscricoes.sort((a, b) => {
                    if (a.mesa && b.mesa) {
                        return a.mesa.index - b.mesa.index;
                    }
                    if (a.mesa) {
                        return -1;
                    }
                    if (b.mesa) {
                        return 1;
                    }
                    return a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1;
                });
                setInscricoes(resultInscricoes);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricoes, mesasReunioes, rodada]);

    useEffect(() => {
        loadInscricao();
    }, [loadInscricao]);

    useEffect(() => {
        let matchsNew = {};
        if (inscricoes) {
            inscricoes.forEach((f) => {
                // só aparecer aba de ancoras em rodadas com ancoras
                if (rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor")) {
                    if (f.tipo === "FORNECEDOR") {
                        return;
                    }
                }

                let produtosVendaA = f.empresa.produtosVenda;
                let produtosCompraA = f.empresa.produtosCompra;

                const uidprodutosVendaA = produtosVendaA?.map((f) => f.uid);
                const uidprodutosCompraA = produtosCompraA?.map((f) => f.uid);
                let newMatchs = [];

                // buscando quem é match
                inscricoes
                    .filter((a) => a.statusEvento !== "AUSENTE" && a.statusEvento !== "SAIU" && f.uid !== a.uid)
                    .forEach((a) => {
                        const { produtosVenda, produtosCompra } = a.empresa;

                        // só aparecer match fornecedor em rodadas com ancoras
                        if (rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor")) {
                            if (a.tipo === "ÂNCORA") {
                                return false;
                            }
                        }

                        let matchsProdutos = [];
                        for (let index = 0; index < produtosVenda?.length; index++) {
                            const produto = produtosVenda[index];

                            if (uidprodutosCompraA?.includes(produto.uid)) {
                                matchsProdutos.push(produto);
                            }
                        }

                        for (let index = 0; index < produtosCompra?.length; index++) {
                            const produto = produtosCompra[index];

                            if (uidprodutosVendaA?.includes(produto.uid)) {
                                matchsProdutos.push(produto);
                            }
                        }

                        if (matchsProdutos.length) {
                            let newA = _.cloneDeep(a);
                            newA.matchsProdutos = matchsProdutos;
                            newMatchs.push(newA);
                        }
                    });
                newMatchs.sort((a, b) => (a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1));
                matchsNew[f.uid] = newMatchs;
            });

            setMatchs(matchsNew);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inscricoes]);

    const mesclaReunioes = (tempReunioes, reunioesSalvas) => {
        let newReunioes = _.cloneDeep(tempReunioes);
        if (newReunioes && newReunioes.length) {
            if (reunioesSalvas && reunioesSalvas.length) {
                for (const key in reunioesSalvas) {
                    const rs = reunioesSalvas[key];
                    let indexR = newReunioes
                        .map((r) => r.horario.horario + r.mesa.uid)
                        .indexOf(rs.horario.horario + rs.mesa.uid);
                    newReunioes[indexR] = rs;
                }
                setReunioes(newReunioes);
            }
        }
    };

    useEffect(() => {
        let observer = null;
        if (rodada && reunioes && !reunioesSalvas) {
            observer = Reuniao.collection
                .where("rodada.uid", "==", rodada.uid)
                .where("status", "==", "ATIVO")
                .onSnapshot((snap) => {
                    let data = [];
                    snap.forEach((doc) => {
                        data.push(doc.data());
                    });
                    data.sort((a, b) => {
                        let aH = a.horariotxt.split("-").reverse().join("");
                        let bH = b.horariotxt.split("-").reverse().join("");
                        return aH > bH ? 1 : -1;
                    });
                    setReunioesSalvas(data);
                    mesclaReunioes(reunioes, data);
                });
        }
        return () => {
            if (observer) observer();
        };
    }, [rodada, reunioes, reunioesSalvas]);

    if (!rodada) {
        return <div>Carregando...</div>;
    }

    const updateReuniao = (reuniao) => {
        // console.log("updateReuniao", reuniao);

        let newReunioes = _.cloneDeep(reunioes);
        let indexR = reuniao.uid
            ? newReunioes.map((r) => r.uid).indexOf(reuniao.uid)
            : newReunioes.map((r) => r.horariotxt + r.mesa.uid).indexOf(reuniao.horariotxt + reuniao.mesa.uid);

        if (!reuniao.uid) {
            reuniao.uid = newReunioes[indexR].uid;
        }
        if (reuniao.status === "INATIVO") {
            if (!reuniao.isNew) {
                setReunioesDeletar((rd) => {
                    let rr = rd || [];
                    rr.push(reuniao);
                    return rr;
                });
            }

            reuniao = {
                uid: reuniao.uid,
                horario: reuniao.horario,
                horariotxt: reuniao.horariotxt,
                mesa: reuniao.mesa,
                rodada: rodada,
                isNew: true,
                status: "ATIVO",
            };
        }

        newReunioes[indexR] = reuniao;
        console.log('reuniao',reuniao)

        setReunioes(newReunioes);
        // let newMesasReunioes = _.cloneDeep(mesasReunioes)
        // let mesaUID = newMesasReunioes.map(a => a.uid).indexOf(reuniao.mesa.uid)
        // let m = newMesasReunioes[mesaUID]
        // let indexR = reuniao.uid ? m.reunioes.map(r => r.uid).indexOf(reuniao.uid) : m.reunioes.map(r => r.horariotxt).indexOf(reuniao.horariotxt)
        // if (!reuniao.uid) {
        //     reuniao.uid = m.reunioes[indexR].uid
        // }
        // m.reunioes[indexR] = reuniao

        // setMesasReunioes(newMesasReunioes)
    };

    const getReunioesInscricao = (uidInscricao, uidInscricao2, newReunioes) => {
        // console.log('uidInscricao', uidInscricao)
        // console.log('uidInscricao2', uidInscricao2)
        let reunioesR = [];

        (newReunioes || reunioes).forEach((r) => {
            if (r.inscricao1 && r.inscricao1.uid === uidInscricao) {
                // console.log('r',r)
                if (uidInscricao2) {
                    if (r.inscricao2 && r.inscricao2.uid === uidInscricao2) {
                        reunioesR.push(r);
                    }
                } else {
                    reunioesR.push(r);
                }
            }
            if (r.inscricao2 && r.inscricao2.uid === uidInscricao) {
                // console.log('r',r)
                if (uidInscricao2) {
                    if (r.inscricao1 && r.inscricao1.uid === uidInscricao2) {
                        reunioesR.push(r);
                    }
                } else {
                    reunioesR.push(r);
                }
            }
        });

        return reunioesR;
    };
    const getHorariosDiponiveis = (uidInscricao, uidInscricao2, newReunioes) => {
        const horariosPossiveis = rodada ? rodada.possiveisReunioes : [];

        let reunioesR = getReunioesInscricao(uidInscricao, null, newReunioes);
        // console.log('reunioesR', reunioesR)
        let reunioesR2 = getReunioesInscricao(uidInscricao2, null, newReunioes);
        // console.log('reunioesR2', reunioesR)

        return horariosPossiveis.filter((horario) => {
            for (const key in reunioesR) {
                const r = reunioesR[key];

                if (horario.horario === r.horario.horario) {
                    return false;
                }
            }
            for (const key in reunioesR2) {
                const r = reunioesR2[key];

                if (horario.horario === r.horario.horario) {
                    return false;
                }
            }
            return true;
        });
    };
    const limparReunioes = () => {
        console.log("limparReunioes", limparReunioes);
        const horariosPossiveis = rodada ? rodada.possiveisReunioes : [];
        let newReunioes = [];
        const criaPreReuniao = (horario, mesa) => {
            return {
                uid: generateUid(),
                horario,
                horariotxt: formatHorarioString(horario.horario),
                mesa: mesa,
                rodada: rodada,
                isNew: true,
                status: "ATIVO",
            };
        };

        let novasMesas = rodada.mesas || [];

        novasMesas.map((mesa) => {
            newReunioes = newReunioes.concat(
                horariosPossiveis.map((h, index) => {
                    return criaPreReuniao(h, mesa);
                })
            );

            return { ...mesa };
        });

        setReunioes(newReunioes);
    };

    const gerarAgendamentos = () => {
        if (
            rodada &&
            (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor") &&
            rodada.mesas &&
            !rodada.mesas.length
        ) {
            showError("Falhou: rodada sem mesa");
        } else if (
            rodada &&
            (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor") &&
            rodada.mesas &&
            rodada.mesas.length &&
            !inscricoes.filter((i) => i.mesa).length
        ) {
            showError("Falhou: ancoras sem mesa");
        } else {
            const ordenaPriorizaFornecedor = (listaMatch, newAncoras) => {
                let r = [];
                listaMatch?.forEach((forn) => {
                    r.push({ forn, numReuniao: getReunioesInscricao(forn.uid).length });
                });
                r.sort((a, b) => {
                    return a.numReuniao - b.numReuniao;
                });

                return r;
            };
            let newReunioes = _.cloneDeep(reunioes);
            let reunioesOrdenada = [].concat(newReunioes || []);
            reunioesOrdenada.sort((a, b) => {
                if (a.horario.horario === b.horario.horario) {
                    return a.mesa.index > b.mesa.index ? 1 : -1;
                }

                return a.horario.horario > b.horario.horario ? 1 : -1;
            });

            inscricoes.forEach((inscricao) => {
                if (rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor")) {
                    if (!inscricao.mesa) {
                        return;
                    }
                }
                // console.log('inscricao.mesa', inscricao.mesa)
                // console.log('inscricao', inscricao)
                let listaMatch = matchs[inscricao.uid];
                let listaMatchOrdenada = ordenaPriorizaFornecedor(listaMatch);
                listaMatchOrdenada.forEach((matchsF) => {
                    let reunioesOrdenadaUsar = reunioesOrdenada.filter((r) => !r.inscricao1 && !r.inscricao2);

                    if (inscricao.mesa) {
                        reunioesOrdenadaUsar = reunioesOrdenadaUsar.filter((r) => r.mesa.uid === inscricao.mesa.uid);
                    }

                    let incri2Tenta = matchsF.forn;
                    // console.log('incri2Tenta', incri2Tenta)
                    let reunioes = getReunioesInscricao(inscricao.uid, incri2Tenta.uid, newReunioes);
                    if (reunioes && !reunioes.length) {
                        //nao tem reuniao ja
                        let horariosDiponiveis = getHorariosDiponiveis(inscricao.uid, incri2Tenta.uid, newReunioes);
                        // console.log('horariosDiponiveis', horariosDiponiveis)
                        let marcar = reunioesOrdenadaUsar.filter((r) => {
                            for (const key in horariosDiponiveis) {
                                if (Object.hasOwnProperty.call(horariosDiponiveis, key)) {
                                    const horario = horariosDiponiveis[key];
                                    if (r.horario.horario === horario.horario) {
                                        return true;
                                    }
                                }
                            }
                            return false;
                        });
                        if (marcar.length) {
                            let marcarZero = marcar[0];
                            // console.log('marcarZero', marcarZero)
                            marcarZero.inscricao1 = inscricao;
                            marcarZero.inscricao2 = incri2Tenta;
                        }
                        //filtra reuniao ordanadas le pega a primeira
                    }
                });
            });

            setReunioes(newReunioes);
            showSuccess("Reniões por agendadas por matchs de produtos");
        }
    };

    const limparAgendamentos = () => {
        let newReunioes = _.cloneDeep(reunioes);
        for (let index = 0; index < newReunioes.length; index++) {
            const r = newReunioes[index];           
            
            if (!r.isNew) {
                setReunioesDeletar((rd) => {
                    let rr = rd || [];
                    rr.push(r);
                    return rr;
                });
            }
       

            newReunioes[index] = {
                uid: r.uid,
                horario: r.horario,
                horariotxt: r.horariotxt,
                mesa: r.mesa,
                rodada: rodada,
                isNew: true,
                status: "ATIVO",
            };
           
        };
        setReunioes(newReunioes);
        showSuccess("Agendamentos limpos");
    };
    const salvarReunioes = () => {
        let newReunioes = _.cloneDeep(reunioes);
        newReunioes = newReunioes.filter((r) => r.inscricao1 && r.inscricao2 && r.mesa && r.horario);
        if (newReunioes.length) {
            setIsSaving(true);
        }
        console.log("salvarReunioes", newReunioes);
        for (const key in newReunioes) {
            const reuniao = newReunioes[key];
            if (reuniao.isNew) {
                delete reuniao.isNew;
            }

            let entity = new Reuniao();
            entity.update(reuniao);

            entity.save().then(() => {
                if (Number(key) + 1 === newReunioes.length) {
                    setIsSaving(false);
                    showSuccess("Reuniões Salvas!");
                }
            });
        }

        for (const key in reunioesDeletar) {
            const reuniao = reunioesDeletar[key];
            reuniao.status = "INATIVO";

            let entity = new Reuniao();
            entity.update(reuniao);

            entity.save().then(() => {
                console.log("salvou reuniao deletar");
            });
        }
    };
    return (
        <div sx={{ width: "100vw" }}>
            {searchRodada && (
                <Button
                    startIcon={<KeyboardReturn />}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        // console.log(`${window.location.origin}/#/painel-controle?rodada=${searchRodada}`)
                        // navigator.clipboard.writeText(`${window.location.origin}/#/painel-controle?rodada=${searchRodada}`)
                        navigate(`/painel-controle?rodada=${searchRodada}`);
                    }}
                    sx={{ width: "100vw", borderRadius: 0 }}
                >
                    Retornar ao painel de controle
                </Button>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", margin: 15 }}>
                <Typography variant="h6">Novo Assistente de Agendamento</Typography>
                <div style={{ display: "flex", gap: 10 }}>
                    <Button onClick={limparAgendamentos}>Limpar Agendamentos</Button>
                    <Button onClick={gerarAgendamentos}>Gerar Agendamentos</Button>
                    {/* <Button onClick={limparReunioes}>Limpar Agendamentos</Button> */}
                    {isSaving ? (
                        <Button onClick={salvarReunioes} disabled>
                            <CircularProgress />
                        </Button>
                    ) : (
                        <Button onClick={salvarReunioes}>Salvar Reuniões</Button>
                    )}
                </div>
            </div>
            <TabContainer
                tab={tab}
                changeTab={setTab}
                tabsProps={{
                    TabIndicatorProps: { sx: { display: "none" } },
                    sx: {
                        "& .MuiTabs-flexContainer": { flexWrap: "wrap" },
                        "& .MuiButtonBase-root-MuiTab-root": { backgroudColor: "#f00" },
                    },
                }}
            >
                {(inscricoes
                    ? rodada && (rodada.tipoAncora === "Comprador" || rodada.tipoAncora === "Vendedor")
                        ? inscricoes.filter((insc) => insc.tipo === "ÂNCORA")
                        : inscricoes
                    : []
                ).map((f, index) => (
                    <TabPanel
                        key={index}
                        label={f.empresa.nomeEmpresaCracha + (f.mesa ? " - " + f.mesa.index : "")}
                        sx={{ m: 1 }}
                    >
                        <MatchsIncricao
                            mesa={f.mesa?.name}
                            incricao={f}
                            index={index}
                            inscricoes={inscricoes}
                            matchs={matchs[f.uid]}
                            rodada={rodada}
                            reunioes={reunioes}
                            updateReuniao={updateReuniao}
                            getReunioesInscricao={getReunioesInscricao}
                            overSaveReuniao={(saveR) => {
                                updateReuniao(saveR);
                            }}
                        />
                    </TabPanel>
                ))}
            </TabContainer>

            <PainelDeReunioes
                rodada={rodada}
                reunioes={reunioes}
                inscricoes={inscricoes}
                deleteOnCard={(r) => {
                    let auxR = r;
                    auxR.status = "INATIVO";
                    updateReuniao(auxR);
                }}
                overSaveReuniao={(saveR) => {
                    updateReuniao(saveR);
                }}
            />
        </div>
    );
}
export default function NovoAssistenteAgendamento(props) {
    return (
        <DefaultCrudForm
            title={"Novo Assistente de Agendamento de Reuniões"}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
        >
            {(props) => {
                return <NovoAssistenteAgendamentoInt {...props} />;
            }}
        </DefaultCrudForm>
    );
}
